export default {
    props: {
        size: {
            type: String,
            default: null
        }
    },
    computed: {
        sizeFormClass() {
            return [
                this.size ? `form-control-${this.size}` : null
            ];
        },
        sizeBtnClass() {
            return [
                this.size ? `btn-${this.size}` : null
            ];
        }
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/lib/mixins/form-size.js
// module id = 109
// module chunks = 2